NHS.Scripts.LazyLoad = function (parameters) {
    this.parameters = parameters;
};

NHS.Scripts.LazyLoad.prototype =
    {
    LazyLoadImages: function() {
        var self = this;

        jQuery("img.async").error(function(element) {
            var parentElement = null;
            var mainImage = null;
            var cardSrpType = document.querySelector("[data-srp-card-type]");

            var parentClass = element.currentTarget.parentElement.parentElement.getAttribute("class");

            if (parentClass) {

                parentElement = element.currentTarget.parentElement.parentElement.parentElement;

                if (cardSrpType &&
                    cardSrpType.getAttribute("data-srp-card-type") === "comm" &&
                    parentElement &&
                    parentElement.querySelector(".imgbox")) {

                    var isMainImage = !element.currentTarget.parentNode.parentNode.classList.contains("imgbox--sm");
                    var leftSideImage = parentElement.querySelector(".imgbox--sm");
                    var rightSideImage = parentElement.querySelectorAll(".imgbox--sm")[1];

                    mainImage = parentElement.querySelector(".imgbox img");
                    parentElement.classList.remove("imgboxes--3");

                    if (isMainImage && mainImage) {
                        self.setOnErrorSrcAttribute(mainImage, self.parameters.NoPhotoBig);
                    }

                    if (leftSideImage && rightSideImage) {
                        leftSideImage.parentNode.removeChild(leftSideImage);
                        rightSideImage.parentNode.removeChild(rightSideImage);
                        mainImage.sizes = "100vw";
                        // self.FitImageInContainer(mainImage, true);
                    }

                } else if (cardSrpType &&
                    cardSrpType.getAttribute("data-srp-card-type") === "home" &&
                    parentElement &&
                    parentElement.querySelector(".imgbox")) {

                    mainImage = parentElement.querySelector(".imgbox img");

                    if (mainImage) {
                        self.setOnErrorSrcAttribute(mainImage, self.parameters.NoPhotoBig);
                    }

                } else if (self.parameters && (parentClass === "mainImage" || parentClass === "nhs_ItemImages")) {
                    self.setOnErrorSrcAttribute(element.currentTarget, self.parameters.NoPhotoBig);
                } else if (self.parameters &&
                    !(parentClass.indexOf(" nhs_BrandImage ") > 0 || parentClass.indexOf("ad-thumb") >= 0)) {
                    self.setOnErrorSrcAttribute(element.currentTarget, self.parameters.NoPhotoSmall);
                } else {
                    self.setOnErrorSrcAttribute(element.currentTarget, self._parameters.builderNoImageRoute);
                }
            }
            jQuery(element).removeClass("async");
        });
    },

    setOnErrorSrcAttribute: function (image, url) {
        const parentElement = image.parentElement;
        if (parentElement.tagName === 'PICTURE') {
            const sources = parentElement.querySelectorAll('source');
            sources.forEach(function(source) {
                source.remove();
            });
        }
        image.onerror = null;
        image.setAttribute("src", url);
    },

    LazyLoadImagesGroup: function (elements) {
        var self = this;
        jQuery(elements).error(function (element) {
            var parentClass = element.currentTarget.parentElement.getAttribute("class");
            if (parentClass) {
                if (self.parameters && (parentClass === "mainImage" || parentClass === "nhs_ItemImages")) {
                    element.currentTarget.setAttribute("src", self.parameters.NoPhotoBig);
                } else if (self.parameters && !(parentClass.indexOf(" nhs_BrandImage ") > 0 || parentClass.indexOf("ad-thumb") >= 0)) {
                    element.currentTarget.setAttribute("src", self.parameters.NoPhotoSmall);
                } else {
                    element.currentTarget.setAttribute("src", "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==");
                }
            }
            jQuery(element).removeClass("async");
        });
    },

    IsThreeImageContainer: function (element) {
        if (element.parentElement &&
            element.parentElement.parentElement &&
            element.parentElement.parentElement.classList.contains("imgboxes--3")) {
            return true;
        }
        return false;
    },

    FitImageInContainer: function (image, isBigCardContainer) {
        var self = this;
        if (image.naturalWidth > 1 && image.naturalHeight > 1) {
            self.OnloadImage(image, isBigCardContainer);
        } else {
            image.addEventListener("load", function () {
                self.OnloadImage(image, isBigCardContainer);
            });
        }
    },

    OnloadImage: function (image, isBigCardContainer) {
        var self = this;
        var parentElement = image.parentNode;

        var isSmallContainer = parentElement.classList.contains("imgbox--sm");
        // constants for the comm box sizes, we were calculating offsetWidth|offsetHeight before, causing reflows and bottle necks
        // with this change the goal is to have faster cards in the new SRP design. Refer to: BDXNHS-4658 | BDXNHS-4665
        var heightForBigContainer = isBigCardContainer ? 178 : 128;
        var widthForBigContainer = 208;
        var heightForSmallContainer = 64;
        var widthForSmallContainer = 103;

        var imgWidth = image.naturalWidth;
        var imgHeight = image.naturalHeight;
        var boxWidth = isSmallContainer ? widthForSmallContainer : widthForBigContainer;
        var boxHeight = isSmallContainer ? heightForSmallContainer : heightForBigContainer;
        var imgRatio = imgWidth / imgHeight;
        var boxRatio = boxWidth / boxHeight;

        image.style.width = 'auto';
        image.style.height = 'auto';

        if (imgRatio > boxRatio) {
            image.classList.add("img--wider");
            image.style.maxWidth = 'none';
            image.style.maxHeight = '100%';

        } else if (imgRatio < boxRatio) {
            image.classList.add("img--taller");
            image.style.maxWidth = '100%';
            image.style.maxHeight = 'none';

        } else {
            image.classList.add("img--same");
            image.style.maxWidth = '100%';
            image.style.maxHeight = 'none';
        }
    }
    };